export default {
    "common": {
        "edit": "editar",
        "welcome_message": "Bienvenido a ELSA para Organizaciones",
        "slogan": "Habla inglés con fluidez, facilidad y confianza",
        "invited_by": "Invitado por",
        "agree_to": "Estoy de acuerdo con el",
        "terms_and_conditions": "Términos y Condiciones de ELSA",
        "search": "Buscar",
        "email": "Correo Electrónico",
        "cancel": "Cancelar",
        "save": "Guardar",
        "or": "o",
        "account_confirmed": "Tu cuenta ha sido confirmada.",
        "no_values": "Sin valores",
        "terms_and_privacy_policy": "Términos Y Política de Privacidad",
        "continue": "Continuar",
        "invite": "Invitar",
        "generic_error_message": "Algo salió mal. Vuelva a intentarlo más tarde.",
        "login": "Iniciar sesión",
        "and": "Y",
        "terms_of_use": "Términos de Uso",
        "privacy_policy": "Política De Privacidad",
        "error_duplidate_group_name": "Duplicar el nombre de la clase en el archivo",
        "name": "Nombre",
        "view_list": "Ver Lista",
        "total": "Total",
        "lessons": "Lecciones",
        "hours": "Horas",
        "average": "Promedio",
        "lessons_per_day": "Lecciones por Día",
        "minutes_per_day": "Minutos por Día",
        "pending_invites": "Invitaciones Pendientes",
        "invite_success": "La invitación fue aceptada con éxito",
        "invite_not_success": "La invitación no pudo ser aceptada",
        "invite_send_not_success": "La invitación no se pudo reenviar",
        "no_invite_seleted": "No hay invitación seleccionada",
        "select_all": "Seleccionar Todo",
        "minutes": "Minutos",
        "warnings": {
            "no_report_data": "No se pudieron obtener los informes, inténtalo de nuevo",
            "session_expired": "Tu sesión ha expirado, por favor inicia sesión"
        },
        "resend_invite": "Reenviar invitación",
        "remove_invite": "Eliminar Invitación Pendiente",
        "export_report": "Exportar Informe",
        "export_assessment": "Exportar Evaluación",
        "lesson_detail": "Detalle de la Lección",
        "file_type_not_allowed": "El tipo de archivo no está permitido",
        "import": "Importar",
        "assessment-history": "Historial de Evaluaciones"
    },
    "company_labels": {
        "groups": "Equipos",
        "teachers": "Líderes del Equipo",
        "students": "Empleados",
        "add_to_group_title": "Añadir al Equipo",
        "add_to_group": "Nuevo Equipo",
        "add_to_group_success": "Los usuarios se han añadido al equipo",
        "add_to_group_warning": "No se pudieron agregar usuarios al equipo",
        "average_lessons": "Número de días practicados por semana",
        "all_users": "Todos los empleados",
        "remove_teacher_from_organization": "Eliminar líder de la organización",
        "remove_student_from_organization": "Eliminar empleado de la organización",
        "remove_student_from_group": "Eliminar al alumno del equipo",
        "remove_from_class_success": "Los usuarios han sido eliminados del equipo",
        "remove_from_class_warning": "No se pudo eliminar a los usuarios del equipo",
        "assign_license_to_user_success": "Asignar la licencia al usuario correctamente",
        "assign_license_to_user_warning": "Asignar licencia al usuario sin éxito",
        "active_students": "Empleados Activos",
        "teacher": "Líder del Equipo",
        "student": "Empleado",
        "all_groups": "Todos los equipos",
        "edit_group": "Editar Equipo",
        "remove_from_group_tilte": "Eliminar del Equipo",
        "remove_teacher": "Eliminar Líder del Equipo",
        "import_class_success_title": "{numberClassesImported} Equipo[s] se han creado con éxito",
        "remove_from_group_success": "Los usuarios han sido eliminados del equipo",
        "remove_from_organization_success": "Los usuarios han sido eliminados de la organización",
        "remove_from_organization_warning": "Los usuarios no pudieron ser eliminados de la organización",
        "remove_from_group_warning": "Los usuarios no pudieron ser eliminados del equipo",
        "remove_teacher_from_group_success": "El maestro ha sido eliminado del equipo",
        "remove_teacher_from_group_warning": "El maestro no pudo ser eliminado del equipo",
        "delete_group_success": "Eliminar equipos con éxito",
        "delete_group_warning": "Eliminar equipos sin éxito",
        "confirm_remove_user_from_group": "¿Estás seguro de que quieres eliminar a este usuario del equipo?",
        "confirm_remove_teacher_from_group": "¿Estás seguro de que quieres eliminar a este maestro del equipo?",
        "create_new_group": "Crear nuevo equipo",
        "no_groups_yet": "Aún no tienes equipos.",
        "no_students_yet": "Aún no tienes empleados.",
        "create_group": "Crear Equipo",
        "import_groups": "Importar equipos",
        "import_groups_success": "Se han creado equipos",
        "import_users_to_groups_success": "Importación de empleados a equipos exitosa",
        "group_title": "Título del equipo",
        "group_name": "Nombre del equipo",
        "group_details": "Detalles del equipo",
        "step_group_details": "{step} . Detalles del equipo",
        "no_teachers_available": "No hay líderes disponibles",
        "all_teachers": "Todos los líderes",
        "all_students": "Todos los Empleados",
        "upload_emails": "Importar empleados al equipo",
        "errors": {
            "please_provide_group_name": "Por favor proporciona un nombre de equipo",
            "please_provide_teacher_name": "Por favor proporciona un nombre de líder"
        },
        "add_students": "Añadir Empleados",
        "group_overview": "Resumen del equipo",
        "group_teacher": "Líder del Equipo",
        "will_be_added_students": "{numberOfUsers} empleados serán agregados a la clase tan pronto como la crees.",
        "student_consent_to_class": "{numberOfUsers} empleados se inscribirán automáticamente en el equipo.",
        "students_list": "Lista de Empleados",
        "your_group_was_created": "Tu equipo fue creado,",
        "error_when_inviting": "pero hubo un error al invitar empleados. Intenta nuevamente más tarde.",
        "invited_users": "¡y {students} empleados fueron invitados!",
        "goals": {
            "engage_students": "Interactúa con tus empleados",
            "engage_review": "Puedes pedirle a tus empleados que empiecen a practicar inglés. Esto es con lo que sugerimos comenzar:",
            "get_insight_about_students": "Obtén información sobre las habilidades de pronunciación actuales de tus empleados"
        },
        "invite_students": "Invitar Empleados",
        "student_name": "Nombre de Empleado",
        "teachers_page": {
            "title": "Líderes del Equipo",
            "invite": "Invitar Líderes",
            "table": {
                "number_of_students": "No. de empleados",
                "number_of_classes": "No. de equipos"
            }
        },
        "students_page": {
            "title": "Empleados",
            "invite": "Invitar Empleados"
        },
        "select_teacher": "Seleccionar un líder",
        "add_new_teacher": "Añadir un nuevo líder",
        "dashboard": {
            "class_overview": "Resumen del equipo",
            "view_class": "Ver Equipo",
            "profile": "Perfil de la Empresa",
            "add_student": "Invitar Empleados",
            "new_group": "Crear Nuevo Equipo",
            "add_teacher": "Invitar Líderes"
        },
        "teacher_info": {
            "show_list_of_classes": "Mostrar Lista de Equipos",
            "show_list_of_students": "Mostrar lista de Empleados",
            "classes_assigned_to": "Equipos asignados a",
            "show_all_classes": "Mostrar todos los equipos"
        },
        "classes": {
            "active_students": "Empleados Activos (Practicaron al Menos una Lección)",
            "import_users": "Importar empleados a equipos múltiples"
        },
        "students_improvement": "Mejora del equipo",
        "auto_enroll_message_confirm": "Los empleados se inscribirán automáticamente en el equipo. <br/> Al elegir la opción de inscripción automática, debes tener permiso previo de los alumnos para agregarlos a esta clase/equipo. <br/> ¿Quieres continuar?",
        "accept_invitation_enroll_message_confirm": "Los empleados tienen que aceptar la invitación de forma individual para inscribirse en el equipo. ¿Quieres continuar?",
        "pending_invites_teacher": "Invitaciones Pendientes del Líder",
        "modals": {
            "delete": {
                "title": "Eliminar equipos de la organización",
                "message": "¿Estás seguro de que deseas eliminar {numberOfClasses} equipos de tu organización?"
            }
        },
        "invite_new_teacher": ""
    },
    "school_labels": {
        "groups": "Clases",
        "teachers": "Profesores",
        "students": "Alumnos",
        "add_to_group_title": "Añadir a Clase",
        "add_to_group": "Nueva Clase",
        "add_to_group_success": "Los usuarios se han añadido a la clase",
        "add_to_group_warning": "No se pudieron agregar usuarios a la clase",
        "remove_from_class_success": "Los usuarios han sido eliminados del equipo",
        "remove_from_class_warning": "No se pudo eliminar a los usuarios del equipo",
        "assign_license_to_user_success": "Asignar la licencia al usuario correctamente",
        "assign_license_to_user_warning": "Asignar licencia al usuario sin éxito",
        "average_lessons": "Número de días practicados por semana",
        "all_users": "Todos los alumnos",
        "teacher": "Profesor",
        "student": "Alumno",
        "active_students": "Alumnos activos",
        "remove_teacher_from_organization": "Eliminar líder de la organización",
        "remove_student_from_organization": "Eliminar estudiante de la organización",
        "remove_student_from_group": "Eliminar al alumno del clase",
        "all_teachers": "Todos los Profesores",
        "all_students": "Todos los Alumnos",
        "all_groups": "Todas las clases",
        "edit_group": "Editar Clase",
        "remove_from_group_tilte": "Eliminar de la Clase",
        "remove_teacher": "Eliminar al Profesor de la Clase",
        "import_class_success_title": "{numberClassesImported} clases se han creado correctamente",
        "remove_from_group_success": "Los usuarios han sido eliminados de la clase",
        "remove_from_organization_success": "Los usuarios han sido eliminados de la organización",
        "remove_from_organization_warning": "Los usuarios no pudieron ser eliminados de la organización",
        "remove_from_group_warning": "Los usuarios no pudieron ser eliminados de la clase",
        "remove_teacher_from_group_success": "El maestro ha sido eliminado de la clase",
        "remove_teacher_from_group_warning": "El maestro no pudo ser eliminado de la clase",
        "delete_group_success": "Eliminar clases con éxito",
        "delete_group_warning": "Eliminar clases sin éxito",
        "confirm_remove_user_from_group": "¿Estás seguro de que quieres eliminar a este usuario de la clase?",
        "confirm_remove_teacher_from_group": "¿Estás seguro de que quieres eliminar a este profesor de la clase?",
        "create_new_group": "Crear nueva clase",
        "no_groups_yet": "Aún no tienes ninguna clase.",
        "no_students_yet": "Aún no tienes alumnos.",
        "no_teachers_available": "No hay maestros disponibles",
        "create_group": "Crear clase",
        "import_groups": "Importar clases",
        "import_groups_success": "Las clases se han creado",
        "import_users_to_groups_success": "Importación de alumnos a clases exitosa",
        "group_title": "Título de la clase",
        "group_name": "Nombre de la Clase",
        "group_details": "Detalles de clase",
        "step_group_details": "{step}. Detalles de clase",
        "select_teacher": "Seleccionar un maestro",
        "add_new_teacher": "Agregar nuevo maestro",
        "upload_emails": "Importar alumnos a la clase",
        "errors": {
            "please_provide_group_name": "Por favor proporciona un nombre para la clase",
            "please_provide_teacher_name": "Por favor proporciona un nombre de maestro"
        },
        "add_students": "Agregar alumnos",
        "group_overview": "Resumen de la clase",
        "group_teacher": "Maestro de la Clase",
        "will_be_added_students": "{numberOfUsers} estudiantes serán agregados a la clase tan pronto como la crees.",
        "student_consent_to_class": "{numberOfUsers} estudiantes se inscribirán automáticamente en la clase.",
        "students_list": "Lista de Alumnos",
        "your_group_was_created": "Tu clase fue creada,",
        "error_when_inviting": "pero hubo un error al invitar estudiantes. Intenta nuevamente más tarde.",
        "invited_users": "¡y {students} alumnos fueron invitados!",
        "goals": {
            "engage_students": "Interactúa con tus alumnos",
            "engage_review": "Puedes pedirle a tus alumnos que empiecen a practicar inglés. Esto es con lo que sugerimos comenzar:",
            "get_insight_about_students": "Obtén información sobre las habilidades de pronunciación actuales de tus alumnos"
        },
        "invite_students": "Invitar alumnos",
        "student_name": "Nombre del Alumno",
        "teachers_page": {
            "title": "Profesores",
            "invite": "Invitar maestros",
            "table": {
                "number_of_students": "no. de alumnos",
                "number_of_classes": "no. de clases"
            }
        },
        "students_page": {
            "title": "Alumnos",
            "invite": "Invitar alumnos"
        },
        "dashboard": {
            "class_overview": "Resumen de la clase",
            "view_class": "Ver Clase",
            "profile": "Perfil de la Escuela",
            "add_student": "Invitar Alumnos",
            "new_group": "Crear Nueva Clase",
            "add_teacher": "Invitar Maestros"
        },
        "teacher_info": {
            "show_list_of_classes": "Mostrar Lista de Clases",
            "show_list_of_students": "Mostrar lista de Alumnos",
            "classes_assigned_to": "Clases asignadas a",
            "show_all_classes": "Mostrar todas las clases"
        },
        "classes": {
            "active_students": "Alumnos Activos (Practicaron al Menos una Lección)",
            "import_users": "Importar alumnos a clases múltiples"
        },
        "students_improvement": "Mejora de la clase",
        "auto_enroll_message_confirm": "Los estudiantes se inscribirán automáticamente en la clase. <br/> Al elegir la opción de inscripción automática, debes tener permiso previo de los alumnos para agregarlos a esta clase. <br/> <br/> ¿Quieres continuar?",
        "accept_invitation_enroll_message_confirm": "Los estudiantes deben aceptar la invitación individualmente para inscribirse en la clase. <br/> ¿Quieres continuar?",
        "pending_invites_teacher": "Invitaciones Pendientes del Maestro",
        "delete_user_from_class_message_confirm":"¿Estás segura de que quieres eliminar a la estudiante?",
        "modals": {
            "delete": {
                "title": "Eliminar clases de la organización",
                "message": "¿Estás seguro de que quieres eliminar {numberOfClasses} clases de tu organización?"
            }
        },
        "invite_new_teacher": ""
    },
    "elsa_goals": {
        "goals": "Usa la mejor aplicación de pronunciación para ayudar a tus estudiantes a mejorar sus habilidades de inglés:",
        "goal1": "Programar clases flexibles",
        "goal2": "Ver informes de progreso",
        "goal3": "Invita a los estudiantes individualmente o en grupo."
    },
    "navbar": {
        "dashboard": "Tablero",
        "classes": "Clases",
        "teachers": "Profesores",
        "students": "Alumnos",
        "account": "Cuenta",
        "my_profile": "Mi Perfil",
        "manage": "Lista de Organización",
        "logout": "Cerrar sesión",
        "hello": "Hola",
        "organizations": "Organizaciones",
        "org_current": "Organización Actual",
        "Language": "Idioma"
    },
    "user_profile": {
        "title": "Vacío",
        "dont_belong_organization": "No perteneces a ninguna organización.",
        "join_organization": "Unirse a la Organización",
        "create_organization": "Crear Organización",
        "withdraw_from_organization": "Retirarse de la organización",
        "your_profile": {
            "title": "tu perfil",
            "first_name": "Primer nombre",
            "last_name": "Apellido",
            "user_name": "Nombre de usuario",
            "email": "Correo Electrónico",
            "not_verified": "No verificado",
            "phone_number": "Número de teléfono",
            "did_not_receive": "¿No recibió el correo electrónico de confirmación?",
            "resent_email": "Reenviar correo electrónico",
            "modals": {
                "edit_profile": {
                    "update_success": "El usuario ha sido actualizado exitosamente.",
                    "title": "Editar perfil",
                    "upload_image": {
                        "label": "Subir imagen"
                    },
                    "first_name": {
                        "label": "Primer nombre",
                        "placeholder": "Ingresa tu primer nombre"
                    },
                    "last_name": {
                        "label": "Apellido",
                        "placeholder": "Ingresa tu apellido"
                    },
                    "email": {
                        "label": "Correo Electrónico",
                        "placeholder": "Ingresa tu dirección de correo electrónico"
                    },
                    "user_name": {
                        "label": "Nombre de usuario",
                        "placeholder": "Ingresa tu nombre de usuario"
                    },
                    "phone": {
                        "label": "Número de teléfono",
                        "placeholder": "+ 1-000-000-0000"
                    },
                    "save": "guardar",
                    "cancel": "cancelar"
                },
                "confirm_new_email": {
                    "title": "Confirma tu nueva dirección de correo electrónico",
                    "message": "Te hemos enviado un correo electrónico de confirmación. Revisa tu bandeja de entrada y verifica tu nueva dirección de correo electrónico.",
                    "button_label": "¡Entendido!"
                }
            }
        },
        "change_password": {
            "title": "cambiar contraseña",
            "password": "contraseña",
            "modals": {
                "title": "cambiar contraseña",
                "current_password": {
                    "label": "Contraseña actual",
                    "placeholder": "Ingresa contraseña actual"
                },
                "new_password": {
                    "label": "Nueva contraseña",
                    "placeholder": "Ingresa nueva contraseña"
                },
                "confirm_new_password": {
                    "label": "Repite nueva contraseña",
                    "placeholder": "Repite nueva contraseña"
                },
                "save": "guardar",
                "cancel": "cancelar",
                "change_pass_elsa": "Utiliza la aplicación de ELSA para cambiar tu contraseña."
            }
        },
        "your_organizations": {
            "title": "tus organizaciones",
            "modals": {
                "title": "retirarse de {name}",
                "admin": {
                    "message_1": "¿Estás seguro de que quieres retirarte de {name}?",
                    "message_2": "Eres el único administrador de {name}. Para retirarte de la organización, invita a otra persona a ser el propietario de la cuenta."
                },
                "teacher": {
                    "message_1": "¿Estás seguro de que quieres retirarte de {name}? Perderás el acceso a tu licencia pro actual.",
                    "message_2": "Eres el maestro asignado de {numberOfClasses} clases. Para retirarte de la organización, comunícate con el administrador de tu organización para que te elimine de ese rol."
                },
                "student": {
                    "message_1": "Si te retiras, necesitarás una nueva invitación para volver a unirte a {name}.",
                    "message_2": "¿Estás seguro de que quieres retirarte de {name}? Perderás el acceso a tu licencia pro actual."
                },
                "confirm": "si, retirarse",
                "cancel": "no, cancelar",
                "got_it": "¡entendido!"
            }
        },
        "social": {
            "title": "social",
            "modals": {
                "title": "Ingresar contraseña",
                "subtitle": "Ingresa una contraseña para poder acceder a tu cuenta de ELSA sin Facebook",
                "password": {
                    "label": "Nueva contraseña",
                    "placeholder": "Ingresa nueva contraseña"
                },
                "repeat_password": {
                    "label": "Repite contraseña nueva",
                    "placeholder": "Repite contraseña nueva"
                },
                "save": "guardar",
                "cancel": "cancelar"
            }
        },
        "delete_account": {
            "button": "eliminar cuenta",
            "modals": {
                "title": "eliminar cuenta",
                "warning": "¿Estás seguro de que deseas retirarte de {organizationName}? Si es así, completa lo siguiente:",
                "terms_and_conditions": "Entiendo que perderé el acceso a mis datos del historial y a mi licencia actual.",
                "password": "Contraseña",
                "delete_account": "eliminar cuenta",
                "cancel": "cancelar"
            }
        }
    },
    "login": {
        "title": "Inicia sesión con tu cuenta de elsa",
        "accept_invitation": "Inicia sesión en tu cuenta de ELSA para aceptar la invitación de {organizationName}.",
        "email_field": {
            "label": "correo electrónico",
            "placeholder": "Ingresar dirección de correo electrónico"
        },
        "password_field": {
            "label": "contraseña",
            "placeholder": "Ingresa tu contraseña"
        },
        "forgot_password": "¿Olvidaste tu contraseña?",
        "login_and_accept_invitation": "Inicia sesión y acepta la invitación",
        "dont_have_account": "¿No tienes una cuenta?",
        "create_account": "Crear una cuenta",
        "login": "Iniciar sesión",
        "invalid_token": "La invitación ha vencido o no es válida"
    },
    "confirm_account": {
        "title": "Confirma tu Cuenta",
        "check_inbox": "Te hemos enviado un correo electrónico de confirmación. Revisa tu bandeja de entrada y verifica tu cuenta.",
        "didnt_receive": "¿No lo recibiste?",
        "resend_confirmation": "Reenviar correo electrónico de confirmación",
        "got_it": "¡Entendido!"
    },
    "resend_confirmation": {
        "title": "Reenviar Correo Electrónico de Confirmación",
        "send_confirmation": "Te enviaremos un nuevo correo electrónico de confirmación. Por favor verifica que tu dirección de correo electrónico es correcta.",
        "email_field": {
            "label": "correo electrónico",
            "placeholder": "Ingresar correo electrónico"
        },
        "resend_email": "Volver a Enviar Correo Electrónico"
    },
    "recover_password": {
        "title": "Recuperar Contraseña",
        "enter_email_to_reset": "Ingresa tu dirección de correo electrónico para que podamos restablecer tu contraseña",
        "email_field": {
            "label": "dirección de correo electrónico",
            "placeholder": "Ingresar dirección de correo electrónico"
        },
        "reset_password": "Restablecer Contraseña",
        "sent_email_check_inbox": "Te hemos enviado un correo electrónico. Revisa tu bandeja de entrada y restablece tu contraseña.",
        "got_it": "¡Entendido!",
        "reset_pass_elsa": "Utiliza la aplicación de ELSA para restablecer tu contraseña."
    },
    "reset_password_modal": {
        "title": "Restablecer contraseña",
        "enter_your_password": "Ingresa tu nueva contraseña",
        "button_text": "Restablecer contraseña",
        "new_password_field": {
            "label": "Nueva Contraseña",
            "placeholder": "Ingresar nueva contraseña"
        },
        "confirm_password_field": {
            "label": "Confirmar nueva Contraseña",
            "placeholder": "Reingresar nueva contraseña"
        }
    },
    "sign_up": {
        "title": "Crear cuenta de ELSA",
        "sign_up": "Registrarse",
        "first_name_field": {
            "label": "Primer Nombre",
            "placeholder": "Ingresar primer nombre"
        },
        "last_name_field": {
            "label": "Apellido",
            "placeholder": "Ingresar apellido"
        },
        "email_field": {
            "label": "Dirección de correo electrónico",
            "placeholder": "Ingresar dirección de correo electrónico"
        },
        "password_field": {
            "label": "Contraseña",
            "placeholder": "Ingresar contraseña"
        },
        "signup_accept_invitation": "Registrarse y Aceptar Invitación",
        "invitation_code": "¿Tienes un código de invitación?",
        "tooltip_message": "Si tienes un código de invitación, ingrésalo aquí.",
        "by_signing_up_to_elsa": "Al registrarte en ELSA, aceptas nuestras",
        "already_have_an_account": "¿Ya tienes una cuenta?",
        "to_our": ""
    },
    "verify_facebook_info_modal": {
        "title": "verifica tu información",
        "save_continue": "Guardar y continuar",
        "first_name_field": {
            "label": "Primer nombre",
            "placeholder": "Primer nombre"
        },
        "last_name_field": {
            "label": "Apellido",
            "placeholder": "Apellido"
        },
        "email_field": {
            "label": "Dirección de correo electrónico",
            "placeholder": "Ingresar dirección de correo electrónico"
        }
    },
    "organizations": {
        "groups": "Grupos",
        "users": "Usuarios",
        "table": {
            "user_email": "Dirección de correo electrónico",
            "username": "Nombre",
            "titleDept": "título / dept.",
            "roles": "Rol",
            "actions": "acciones",
            "empty": "No se encontró usuario",
            "empty_admin": "No se encontraron administradores",
            "empty_student": "No se encontraron alumnos",
            "empty_teacher": "No se encontraron maestros"
        },
        "users_section": {
            "invite_users": "Invitar usuarios",
            "invite_by_email": "Invitar por correo electrónico",
            "import_users": "Importar usuarios a múltiples grupos",
            "share_code": "Obtener un código",
            "share_link": "Compartir un link",
            "share_qr_code": "Compartir código QR",
            "add_to_group": "Añadir al grupo",
            "add_to_class": "Añadir a clase",
            "revoke_license": "Revocar licencia",
            "enable_license": "Habilitar licencia",
            "disable": "Deshabilitar",
            "delete": "Eliminar",
            "no_users": "Invita usuarios a unirse a tu empresa:",
            "no_users_1": "Aún no tienes usuarios.",
            "no_users_2": "Agrega usuarios o comparte tu organización con ellos.",
            "select_role": "Seleccionar rol",
            "user_profile": {
                "user_details": {
                    "title": "Detalles del usuario"
                },
                "user_roles": {
                    "title": "Rol del usuario"
                }
            },
            "enable_license_message": "Licencia Pro expedida para {firstName} {lastName}",
            "modals": {
                "share_qr_code": {
                    "title": "compartir código QR",
                    "print_code": "Imprime el siguiente código QR",
                    "share_with_users": "Compártelo con usuarios para que puedan escanearlo y unirse a tu organización.",
                    "print": "Imprimir",
                    "no_cancel": "Cancelar"
                },
                "share_link": {
                    "title": "compartir un link",
                    "copy_link": "Copiar link",
                    "got_it": "¡Entendido!",
                    "cancel": "Cancelar"
                },
                "share_code": {
                    "title": "Obtener un código",
                    "share_the_following_code": "Generar un código",
                    "user_can_join": "Comparte el código con usuarios para que puedan utilizarlo para unirse a tu organización.",
                    "generate_code": "Generar código",
                    "done": "Hecho"
                },
                "invite_users": {
                    "copy_and_paste": "Copiar y pegar direcciones de correo electrónico",
                    "title": "Enviar invitación por correo electrónico",
                    "select_role_placeholder": "Selecciona el rol del usuario",
                    "select_role_label": "Rol de usuario(s)",
                    "copy_paste_emails": "Copiar y pegar direcciones de correo electrónico",
                    "invite_users": "Invitar Usuarios",
                    "add_email": "Insertar varias direcciones de correo electrónico (separadas por comas)",
                    "success": "Los usuarios se han agregado a la lista de usuarios",
                    "consent": "Consentimiento",
                    "consent1": "Inscribir automáticamente usuario(s) en {organizationName}"
                },
                "edit_user": {
                    "update_success": "Actualizar éxito",
                    "title": "Editar Rol de Usuario",
                    "user_title": "Seleccionar titulo",
                    "user_title_placeholder": "Título",
                    "department": "Seleccionar departamento",
                    "department_placeholder": "Departamento"
                },
                "disable": {
                    "title": "Deshabilitar {numberOfAccounts} cuentas de usuarios",
                    "message": "¿Estás seguro de que quieres revocar las licencias pro de {numberOfAccounts} usuarios?",
                    "confirm": "Sí, Revocar",
                    "cancel": "No, Cancelar"
                },
                "delete": {
                    "title": "Eliminar usuarios de la organización",
                    "message": "¿Estás seguro de que quieres eliminar {numberOfAccounts} usuarios de tu organización?",
                    "confirm": "Sí, Eliminar",
                    "cancel": "No, Cancelar"
                },
                "delete_from_class": {
                    "title": "Eliminar usuarios del equipo",
                    "message":
                      "¿Está seguro de que desea eliminar {numberOfAccounts} usuario (s) de su equipo?",
                    "confirm": "Sí, Eliminar",
                    "cancel": "No, Cancelar"
                }
            },
            "popovers": {
                "groups": {
                    "title": "Añadir al Grupo",
                    "add_group": "Añadir grupo",
                    "manage_groups": "Administrar grupos"
                },
                "classes": {
                    "title": "Añadir a Clase",
                    "new_class": "Nueva clase"
                },
                "roles": {
                    "title": "Editar Roles"
                }
            },
            "import_elsa_id": "Importar Elsa_Id a varios grupos"
        },
        "invite_users": {
            "title": "Invitar Usuarios",
            "subtitle": "Invita usuarios a unirse a tu empresa:",
            "import_users": "Importar lista de direcciones de correo electrónico al grupo seleccionado",
            "share_link": "Compartir un link",
            "mail_invite": "Copiar y pegar direcciones de correo electrónico",
            "import": {
                "title": "importar lista de direcciones de correo electrónico",
                "subtitle": "Importar lista",
                "instructions": "Arrastra y suelta los archivos aquí para subirlos.",
                "files": "{fileCount} archivo(s) se han subido",
                "instructions2": "Descarga la plantilla en",
                "get_template": "Obtener plantilla",
                "browse_files": "Explorar archivos",
                "elsa-title": "importar lista de ID de usuarios de Elsa",
                "instructions3": "complétala y arrástrala para importar",
                "get_template_xlsx": "Formato MS Excel",
                "get_template_csv": "Formato CSV"
            },
            "link": {
                "one": "unos",
                "other": "otros"
            },
            "mail": {
                "title": "Copiar y pegar direcciones de correo electrónico"
            },
            "import_users_classes": "Importar lista de direcciones de correo electrónico a muchos grupos",
            "multiple_mail_invite_with_enrolled": "Se ha inscrito al grupo a {numberOfInvites} usuario (s)",
            "multiple_mail_invite": "Se ha invitado a {numberOfInvites} usuario (s)",
            "multiple_mail_to_invite": "Se invitará a {numberOfInvites} usuario (s)",
            "confirmation_title": "Confirmación",
            "warning_message_delay_invite": "Por favor, ten en cuenta: El proceso de invitación puede tardar unos minutos en completarse. Vuelve más tarde para ver la lista de usuarios actualizada."
        }
    },
    "table_row": {
        "actions": {
            "remove_from_group": "Eliminar del grupo",
            "add_to_class": "Añadir a clase",
            "disable": "Deshabilitar",
            "delete": "Eliminar"
        }
    },
    "organization_profile": {
        "title": "Perfil",
        "admins": "Administrador(es)",
        "invite_another_admin": "Invitar a otro administrador",
        "pending_request": "Solicitud Pendiente",
        "organization_name": "Nombre de la Organización",
        "organization_username": "Nombre de Usuario de la Organización",
        "organization_type_industry": "Tipo de Organización/Industria",
        "phone": "Número de Teléfono",
        "address": "Dirección",
        "affiliate": "Afiliado",
        "admin_actions": {
            "remove_from_admin": "Eliminar",
            "edit_user": "Editar Usuario",
            "remove_from_organization": "Eliminar de la organización",
            "user_id_only_admin": "No se puede eliminar al único administrador de una organización."
        },
        "remove_admin_modal": {
            "title": "Eliminar Administrador",
            "yes_remove": "Sí, eliminar",
            "no_cancel": "No, cancelar"
        },
        "invite_admin_modal": {
            "invite_success": "La invitación ha sido enviada.",
            "title": "Invitar a un Nuevo Administrador",
            "email_field": {
                "label": "Dirección de Correo Electrónico",
                "placeholder": "Ingresar dirección de correo electrónico"
            },
            "invite_button": "Invitar",
            "cancel_button": "Cancelar",
            "remove_invite_success": "Eliminación de invitación con éxito",
            "remove_invite_fail": "Eliminación de invitación sin éxito",
            "confirm_remove_invitation": "¿Quieres eliminar esta invitación?"
        },
        "delete_disable_organization_modal": {
            "title_delete": "Eliminar",
            "title_disable": "Deshabilitar",
            "title_enable": "Habilitar",
            "password_field": {
                "label": "contraseña",
                "placeholder": "Ingresar contraseña"
            },
            "delete_button": "Eliminar organización",
            "disable_button": "Sí, deshabilitar",
            "enable_button": "Sí, habilitar",
            "cancel_button": "Cancelar",
            "delete_terms": "Entiendo que perderé el acceso a mis datos de historial y mis licencias actuales.",
            "disable_terms": "Entiendo que los usuarios perderán sus licencias de pago.",
            "are_you_sure_disable": "¿Estás seguro de que quieres deshabilitar?",
            "are_you_sure_enable": "¿Estás seguro de que quieres habilitar?",
            "are_you_sure_widthraw": "Estás seguro de que quieres retirarte de",
            "if_so_fill_following": "Si es así, por favor proporcione la siguiente información:"
        },
        "edit_organization_modal": {
            "invite_not_send": "Se creó la organización, pero no se pudieron enviar las invitaciones.",
            "update_success": "La organización ha sido actualizada",
            "create_success": "La organización ha sido creada",
            "create_title": "Crear nueva organización",
            "edit_title": "Editar organización",
            "save": "Guardar",
            "cancel": "Cancelar",
            "upload_logo_field": {
                "label": "Subir logo"
            },
            "verified_organization": "Verificar organización",
            "enable_organization": "Habilitar organización",
            "disable_organization": "Deshabilitar organización",
            "delete_organization": "Eliminar organización",
            "are_you_sure_disable": "¿Estás seguro de que quieres deshabilitar?",
            "name_field": {
                "label": "Nombre de la Organización",
                "placeholder": "Ingresar nombre de la organización"
            },
            "username_field": {
                "label": "Nombre de usuario",
                "placeholder": "Ingresar nombre de usuario de la organización"
            },
            "org_type_field": {
                "label": "Tipo de organización",
                "placeholder": "Seleccionar tipo de organización"
            },
            "industry_field": {
                "label": "Industria",
                "placeholder": "Seleccionar industria"
            },
            "address_field": {
                "label": "Dirección",
                "placeholder": "Ingresar dirección de la organización"
            },
            "phone_field": {
                "label": "Número de teléfono",
                "placeholder": "+ 1-000-000-0000"
            },
            "country_field": {
                "label": "País",
                "placeholder": "Ingresar país"
            },
            "state_field": {
                "label": "Estado/Provincia",
                "placeholder": "Ingresar estado/provincia"
            },
            "city_field": {
                "label": "Ciudad",
                "placeholder": "Ingresar ciudad"
            },
            "post_code_field": {
                "label": "Código Postal",
                "placeholder": "Código Postal"
            },
            "owner_field": {
                "label": "Propietario de la Cuenta",
                "placeholder": "Propietario"
            },
            "affiliate_field": {
                "label": "Afiliado",
                "placeholder": "Ninguno"
            },
            "timezone_field": {
                "label": "Zona horaria",
                "placeholder": "Etc/GMT"
            }
        }
    },
    "admin": {
        "organizations": {
            "title": "Organizaciones",
            "create_new_organization": "Crear nueva organización",
            "import_organizations": "Importar organizaciones",
            "verify": "Verificar",
            "table": {
                "organization_name": "Nombre de la organización",
                "status": "estado",
                "licences": "Licencias",
                "empty": "No se encontró organización",
                "verification": "Verificación",
                "not_verified": "No Verificado",
                "verified": "Verificado",
                "active": "Activo",
                "inactive": "Deshabilitado",
                "affiliate": "Afiliado",
                "created_at": "Fecha de creación"
            },
            "filter_menu": {
                "all": "Todos",
                "active": "Activo",
                "disable": "Deshabilitar",
                "verified": "Verificado",
                "disabled": "Deshabilitado"
            }
        }
    },
    "organization_page": {
        "organizations": "Organizaciones",
        "disable": "Deshabilitar",
        "delete": "Eliminar",
        "menu": {
            "licences": "Licencias",
            "users": {
                "title": "Usuarios",
                "all_users": "Todos los usuarios",
                "employees": "Empleados",
                "leads": "Líderes del Equipo",
                "admins": "Administradores"
            },
            "groups": "Grupos",
            "profile": "Perfil"
        }
    },
    "disable_organization_modal": {
        "title": "Deshabilitar",
        "yes_disable": "Sí, deshabilitar",
        "no_cancel": "No, cancelar"
    },
    "onboarding": {
        "welcome": "Bienvenido a ELSA",
        "welcome_subtitle": "Cuéntanos un poco más sobre ti, para que podamos guiarte en tu viaje ELSA.",
        "who_are_you": "¿Quién eres?",
        "select_option": "Selecciona una de las siguientes opciones",
        "school": "Escuela",
        "school_admin": "Administrador de la Escuela",
        "company": "Empresa",
        "company_admin": "Administrador de la Empresa",
        "teacher": "Profesor",
        "student": "Alumno",
        "continue": "Continuar"
    },
    "school": {
        "setup_school": {
            "successfully_created": "Tu escuela fue creada con éxito.",
            "setup_your_school": "Configura tu escuela",
            "invite_students_teachers": "Invita a tus alumnos y profesores a unirse a tu organización.",
            "create_your_first_class": "¡Crea tu primera clase!",
            "create_class": "Crear clase",
            "invite_teachers": "Invitar maestros",
            "invite_students": "Invitar alumnos",
            "teacher": "Profesor",
            "continue": "Continuar"
        },
        "create_edit_modal": {
            "title": "Crear Escuela",
            "create": "Crear",
            "cancel": "Cancelar",
            "name_field": {
                "label": "Nombre de escuela",
                "placeholder": "Ingresar nombre de la escuela"
            },
            "username_fields": {
                "label": "Nombre de usuario",
                "placeholder": "Ingresar nombre de usuario de la escuela"
            },
            "type_field": {
                "label": "Tipo de Escuela",
                "placeholder": "Seleccionar tipo de escuela"
            },
            "industry_field": {
                "label": "Industria",
                "placeholder": "Seleccionar industria"
            },
            "address_field": {
                "label": "Dirección",
                "placeholder": "Seleccionar dirección de la escuela"
            },
            "phone_field": {
                "label": "Número de teléfono",
                "placeholder": "+ 1-000-000-0000",
                "code": "Código"
            },
            "country_field": {
                "label": "País",
                "placeholder": "Ingresar país"
            },
            "state_field": {
                "label": "Estado/Provincia",
                "placeholder": "Ingresar estado/provincia"
            },
            "city_field": {
                "label": "Ciudad",
                "placeholder": "Ingresar ciudad"
            },
            "post_code_field": {
                "label": "Código Postal",
                "placeholder": "0000-00"
            }
        }
    },
    "company": {
        "setup_company": {
            "successfully_created": "Tu empresa fue creada con éxito.",
            "setup_your_company": "Configura tu empresa",
            "invite_students_teachers": "Invita a tus alumnos y profesores a unirse a tu empresa.",
            "create_class": "Crear clase",
            "invite_teachers": "Invitar maestros",
            "invite_students": "Invitar alumnos",
            "continue": "Continuar"
        },
        "create_edit_modal": {
            "title": "Crear empresa",
            "create": "Crear",
            "cancel": "Cancelar",
            "name_field": {
                "label": "Nombre de la Empresa",
                "placeholder": "Ingresar nombre de la empresa"
            },
            "username_field": {
                "label": "Nombre de usuario de la empresa",
                "placeholder": "Ingresar nombre de usuario de la empresa"
            },
            "type_field": {
                "label": "Tipo de empresa",
                "placeholder": "Ingresar tipo de empresa"
            },
            "industry_field": {
                "label": "Tipo de industria",
                "placeholder": "Ingresar industria"
            },
            "address_field": {
                "label": "Dirección",
                "placeholder": "Ingresar dirección de la escuela"
            },
            "phone_field": {
                "label": "Número de teléfono",
                "placeholder": "+ 1-000-000-0000",
                "code": "Código"
            },
            "country_field": {
                "label": "País",
                "placeholder": "Ingresar país"
            },
            "state_field": {
                "label": "Estado/Provincia",
                "placeholder": "Ingresar estado/provincia"
            },
            "city_field": {
                "label": "Ciudad",
                "placeholder": "Ingresar ciudad"
            },
            "post_code_field": {
                "label": "Código postal",
                "placeholder": "0000-00"
            }
        }
    },
    "teacher": {
        "are_you_part_of_organization": "¿Eres parte de una organización?",
        "select_one_options": "Selecciona una de las siguientes opciones",
        "yes": "Si",
        "no": "No",
        "teach_myself": "Yo enseño solo",
        "continue": "Continuar",
        "do_you_have_invitation_code": "¿Tienes un código de invitación?"
    },
    "student": {
        "are_you_part_of_organization": "¿Eres parte de una organización?",
        "select_one_options": "Selecciona una de las siguientes opciones",
        "yes": "Si",
        "no": "No",
        "learning_myself": "Estoy estudiando por mi cuenta",
        "continue": "Continuar",
        "do_you_have_invitation_code": "¿Tienes un código de invitación?"
    },
    "setup_organization": {
        "join_your_organization": "Únete a tu organización",
        "wait_for_admin": "Espera a que tu administrador te envíe una invitación o ingresa un código de invitación.",
        "enter_invitation_code": "Ingresar código de invitación",
        "continue": "continuar",
        "welcome_to_organization": "Bienvenido a la organización A",
        "you_can_create_own_class": "Puedes crear tu propia clase o esperar a que tu administrador te asigne a una clase",
        "create_class": "Crear clase"
    },
    "start_learning": {
        "start_learning": "Empezar a aprender",
        "download_elsa_app": "Descarga la aplicación de ELSA en tu dispositivo móvil:",
        "or_send_the_email_by_link_sms": "O recibe un enlace de descarga por correo electrónico o SMS/mensaje de texto:",
        "send_email_link": "envíame un link por correo electrónico",
        "send_sms_link": "envíame un link por SMS",
        "start_practice": "Empieza a practicar",
        "you_can_download": "Puedes descargar la aplicación y empezar a practicar:",
        "to_join_our_organization": "Para unirte a tu organización, espera que tu administrador te invite o ingresa un código de invitación",
        "enter_invitation_code": "Ingresar código de invitación",
        "email_link_sent": "Link enviado por correo electrónico",
        "sms_link_sent": "Link enviado por SMS",
        "get_email_link_modal": {
            "title": "Obtener link por correo electrónico",
            "get_email_link": "Obtener link por correo electrónico",
            "email_field": {
                "label": "Correo electrónico",
                "placeholder": "Ingresar dirección de correo electrónico"
            },
            "phone_type_field": {
                "label": "Tipo de teléfono",
                "placeholder": "Tipo de teléfono"
            },
            "success": "El correo electrónico enviado",
            "warning": "El correo electrónico no se pudo enviar, inténtalo de nuevo más tarde"
        },
        "send_sms_link_modal": {
            "title": "Obtener link por SMS",
            "get_sms_link": "Obtener link por SMS",
            "phone_type_field": {
                "label": "Tipo de teléfono",
                "placeholder": "Tipo de teléfono"
            },
            "phone_field": {
                "label": "Teléfono",
                "placeholder": "+ 1-000-000-0000",
                "code": "Código"
            },
            "success": "SMS enviado",
            "warning": "SMS no pudo ser enviado, intenta nuevamente más tarde"
        }
    },
    "industries": {
        "aerospace": "Aeroespacial",
        "transportation": "Transporte",
        "computer_software_internet": "Computación, Software e Internet",
        "telecommunication": "Telecomunicaciones",
        "food_and_agriculture": "Alimentación y Agricultura",
        "construction": "Construcción",
        "education": "Educación",
        "healthcare": "Cuidado de la salud",
        "travel_and_hospitality": "Viajes y Hospitalidad",
        "entertainment_news_media_music": "Entretenimiento, Noticias y Medios de Comunicación",
        "energy": "Energía",
        "manufacturing": "Manufactura",
        "fashion_and_clothing": "Moda y Ropa",
        "mining": "Minería",
        "consulting_services": "Consultoría/Servicios",
        "other": "Otro"
    },
    "classes": {
        "name": "Clases",
        "no_classes_yet": "Aún no tienes clases.",
        "create_class": "Crear clase",
        "create_new_class": "Crear nueva clase",
        "accepted_users": "Usuarios aceptados",
        "pending_users": "Usuarios pendientes",
        "filter_menu": {
            "all": "Todos",
            "active": "Activo",
            "not_started": "No Empezado",
            "draft": "Borradores",
            "finished": "Terminado"
        },
        "success_class_updated": "La clase se actualizó con éxito",
        "success_remove_user":"Eliminar al usuario de la clase con éxito",
        "reports": "Informes",
        "table_titles": {
            "start_date": "Fecha de Inicio",
            "end_date": "Fecha de Finalización",
            "status": "Estado"
        },
        "classes_details": {
            "left": "izquierda",
            "to_go": "irse",
            "edit_class_name": "Editar {name}",
            "menu": {
                "overview": "Resumen",
                "detailed_progress": "Progreso Detallado",
                "time_tracking": "Seguimiento de Tiempo"
            },
            "overview_section": {
                "title": "Resumen",
                "students": "estudiantes",
                "view_list": "Ver Lista",
                "goals": "Metas",
                "no_goals_set": "No hay metas establecidas para esta clase.",
                "minutes_per_day": "Minutos por día",
                "days_practice_per_week": "días de práctica por semana",
                "set_goals": "Establecer metas",
                "assessment_test_results": "Resultado de la prueba de evaluación",
                "average_score": "Puntuación Promedio",
                "test_before_class_stats": "Días para realizar la prueba de evaluación"
            },
            "students_section": {
                "title": "Alumnos",
                "pro_licence": "Licencia Pro",
                "assessment_test": "Puntuación de Evaluación",
                "date_take_assessment": "Fecha de Evaluación",
                "last_active_practice": "Tiempo de Última Práctica",
                "practice_days_week": "Días de práctica de la semana",
                "min_spent": "Min. invertidos",
                "last_eps": "Último PPE",
                "avg_daily_use": "Uso diario promedio (min)",
                "copy_paste_emails": "Copiar y Pegar direcciones de correos electrónicos",
                "module_name": "Nombre del Módulo",
                "lesson_name": "Nombre de la Lección",
                "lesson_EPS": "lección PPE",
                "lesson_take_date": "Fecha de la Lección",
                "difficulty_level": "Nivel de Dificultad",
                "skill_name": "Nombre de la Habilidad",
                "skill_score": "Puntuación"
            },
            "activity_reports": {
                "title": "Reportes de Actividad",
                "lessons_overview": "Resumen de lecciones",
                "number_of_lessons_practiced": "Número de Lecciones y Minutos Practicados",
                "average_practice": "Tiempo Promedio de Práctica por Día (Minutos)",
                "progress": "Gráfica de Progreso (PPE Promedio)",
                "progress_student": "Gráfica de Progreso (PPE)",
                "0_5_percent": "0% - 5%",
                "6_10_percent": "6% - 10%",
                "11_50_percent": "11% - 50%",
                "51_70_percent": "51% - 70%",
                "mt_70_percent": "Más del 70%"
            }
        },
        "create_class_flow": {
            "save_finish_later": "Guardar y terminar más tarde",
            "cancel": "Cancelar",
            "save": "Guardar",
            "next": "Siguiente",
            "previous": "Anterior",
            "details": "Detalles",
            "list_students_modal": {
                "got_it": "¡Entendido!",
                "warning_no_student": "Ningún estudiante será invitado"
            },
            "class_details": {
                "start_end_date": "Fecha de Inicio y Finalización"
            },
            "add_students": {
                "copy_paste_emails": "Copiar y pegar direcciones de correos electrónicos",
                "insert_multiple_emails": "Insertar varios correos electrónicos (separados por comas)"
            },
            "class_overview": {
                "details": "Detalles",
                "start_end_date": "Fecha de Inicio y Finalización",
                "not_selected": "No Seleccionado",
                "create_and_send_invites": "Crear y enviar invitaciones"
            },
            "class_created": {
                "goals_section": {
                    "practice_at_least": "Practica al menos",
                    "days_week": "días a la semana.",
                    "keep_them_engaged": "Manténlos comprometidos semanalmente",
                    "practice": "Práctica",
                    "minutes_day": "minutos al día.",
                    "studies_review": "Estudios demuestran que practicar al menos 10 minutos al día produce los mejores resultados al aprender un nuevo idioma.",
                    "take_assessment_test": "Realiza la Prueba de Evaluación en",
                    "days_before_invitations": "días después de la invitación.",
                    "next": "Siguiente",
                    "will_do_this_later": "Haré esto más tarde."
                }
            }
        }
    },
    "date_interval_picker": {
        "start_end_date": "Fecha de Inicio y Finalización",
        "save": "Guardar",
        "cancel": "Cancelar",
        "this_month": "Este Mes",
        "apply": "Aplicar"
    },
    "date_picker": {
        "start_date": "Fecha de Inicio",
        "end_date": "Fecha de Finalización",
        "to": "A",
        "last_week": "La semana pasada",
        "last_month": "El mes pasado",
        "last_three_months": "Los últimos 3 meses",
        "last_six_months": "Los últimos 6 meses",
        "last_year": "El año pasado",
        "daily": "Diario",
        "weekly": "Semanal",
        "monthly": "Mensual"
    },
    "teacher_info": {
        "profile": "Perfil",
        "first_name": "Primer Nombre",
        "last_name": "Apellido",
        "email": "correo electrónico",
        "username": "Nombre de usuario",
        "phone_number": "Número de Teléfono",
        "user_roles": "Roles del usuario",
        "department": "Departamento",
        "title": "Título",
        "user_role": "Rol del usuario",
        "overview": "Resumen"
    },
    "student_info": {
        "overview": "Resumen",
        "profile": "Perfil"
    },
    "dashboard": {
        "reports_overview": "Resumen del Informe",
        "notifications": "Notificaciones",
        "overview": "Resumen",
        "manage": "Administrar",
        "licenses": "Licencias",
        "users": "Usuarios",
        "request_license": "Solicitar Licencia",
        "student": {
            "view_class": "Ver clase",
            "view_all_classes": "ver Todas las clases",
            "goals": {
                "minutes_per_day": "Objetivo de { minutes } minutos por día",
                "minutes_per_day_value": "Tu promedio es de { minutes } minutos por día",
                "days_per_week": "Objetivo de {days} Días por Semana",
                "days_per_week_value": "Su Promedio es de {days} días de práctica por Semana",
                "level": "Nivel {level}",
                "level_value": "Promedio de {level} %"
            },
            "minutes_spend_per_day": "Minutos es el tiempo promedio invertido por día"
        }
    },
    "charts": {
        "active_users": "Usuarios activos",
        "avg_practice_time": "Tiempo promedio de práctica",
        "avg_eps": "PPE",
        "number_of_lessons": "Número de lecciones",
        "number_of_seconds": "Tiempo invertido",
        "user_eps_score": "PPE",
        "not_active": "No activo",
        "1_4_days": "1-4 días a la semana",
        "5_5_days": "5 días a la semana",
        "6_7_days": "6-7 días a la semana",
        "percentage": "Porcentaje"
    }
};
